import React, {
  PropsWithChildren,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from "react";

interface FadeInViewProps {
  children: React.ReactNode;
  zIndex?: number; // Add any other props you need
}

export const FadeInView: React.FC<FadeInViewProps> = ({ children, zIndex }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const checkVisibility = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const fadeInThreshold = 0.8; // Threshold for fading in
      const fadeOutThreshold = 0.8; // Threshold for fading out

      // Calculate the visibility for fade-in and fade-out
      const fadeInVisible =
        rect.top >= 0 && rect.top <= window.innerHeight * fadeInThreshold;
      const fadeOutVisible =
        rect.bottom >= 0 &&
        rect.bottom <= window.innerHeight * fadeOutThreshold;

      setIsVisible(fadeInVisible || fadeOutVisible);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", checkVisibility);
    checkVisibility(); // Initial check on mount

    return () => {
      window.removeEventListener("scroll", checkVisibility);
    };
  }, []);

  return (
    <div
      ref={ref}
      className={isVisible ? "fade-in" : "fade-out"}
      style={{ zIndex }}
    >
      {children}
    </div>
  );
};
